import './Title.css';
export default function Title() {
  return (
    <div className="Title">
      <h1>Expr <sup>n</sup></h1>
      <hr />
    </div>
  )
}
